// StartHere: the one-liner at the top of every board — the single most useful next
// move for Jeff right now, with its button inline. Honest zero when nothing waits.
export const StartHere = ({ tone = "amber", text, button, meta, testId = "cc-start-here" }) => {
  const toneClass = tone === "green" ? "text-os-green" : tone === "amber" ? "text-os-ink" : "text-os-ink-2";
  return (
    <div
      data-testid={testId}
      data-tone={tone}
      className="flex flex-wrap items-center gap-x-3 gap-y-2 rounded-card border border-os-border os-card px-5 py-3"
    >
      <span className="font-mono text-[0.6875rem] uppercase tracking-[0.14em] text-os-ink-3">Start here</span>
      <p className={`text-[0.9375rem] font-medium ${toneClass}`}>{text}</p>
      {button && (
        <button
          type="button"
          data-testid={`${testId}-button`}
          onClick={button.onClick}
          disabled={button.disabled}
          className="ml-auto rounded-md border border-os-border px-3 py-1.5 font-mono text-[0.75rem] text-os-ink hover:border-os-border-strong disabled:opacity-50"
        >
          {button.label}
        </button>
      )}
      {meta && <span className="font-mono text-[0.6875rem] text-os-ink-3">{meta}</span>}
    </div>
  );
};

export default StartHere;